import { useEffect, useState } from "react";

import {
  getOrgSurveyConfigPortal,
  type SurveyConfiguration,
} from "@rubi/api-generated";

export const useCurrentSurveyConfig = (
  orgId: string | undefined,
  surveyClass: string | undefined,
) => {
  const requestKey = `${orgId ?? ""}:${surveyClass ?? ""}`;
  const [surveyConfigState, setSurveyConfigState] = useState<{
    requestKey: string;
    surveyConfig: SurveyConfiguration | null;
  }>({ requestKey: "", surveyConfig: null });

  useEffect(() => {
    let cancelled = false;

    setSurveyConfigState({ requestKey, surveyConfig: null });
    if (!orgId || !surveyClass) return;

    const fetchCurrentSurveyConfig = async () => {
      try {
        const response = await getOrgSurveyConfigPortal({
          path: { org_id: orgId },
        });
        const survey = response.data?.surveys?.find(
          (configuration) => configuration.survey_class === surveyClass,
        );

        if (!cancelled) {
          setSurveyConfigState({ requestKey, surveyConfig: survey ?? null });
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch current survey configuration:", error);
        }
      }
    };

    fetchCurrentSurveyConfig();

    return () => {
      cancelled = true;
    };
  }, [orgId, requestKey, surveyClass]);

  return surveyConfigState.requestKey === requestKey
    ? surveyConfigState.surveyConfig
    : null;
};
